import { render } from "./IconEye.vue?vue&type=template&id=530c226d"
import script from "./IconEye.vue?vue&type=script&lang=js"
export * from "./IconEye.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__